import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-email-2fa-modal',
  template: `
    <div class="modal-header">
      <h5 class="modal-title">{{ 'navigations.account.email_2fa_title' | translate }}</h5>
      <button type="button" class="close" (click)="cancel.emit()" [disabled]="isBusy">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-container *ngIf="step === 'send'">
        <p class="text-muted small mb-3">
          {{ 'navigations.account.email_2fa_send_description' | translate:{ email: maskedEmail } }}
        </p>
        <div *ngIf="errorMessage" class="alert alert-danger py-2 small mb-2">
          {{ errorMessage }}
        </div>
      </ng-container>

      <ng-container *ngIf="step === 'verify'">
        <p class="text-muted small mb-3">
          {{ 'navigations.account.email_2fa_description' | translate:{ email: maskedEmail } }}
        </p>
        <div class="form-group mb-2">
          <label for="email2fa-code">{{ 'navigations.account.email_2fa_code_label' | translate }}</label>
          <input
            id="email2fa-code"
            type="text"
            class="form-control"
            maxlength="6"
            inputmode="numeric"
            autocomplete="one-time-code"
            [disabled]="isBusy"
            [(ngModel)]="code"
            (keyup.enter)="onVerify()"
          />
        </div>
        <div *ngIf="errorMessage" class="alert alert-danger py-2 small mb-2">
          {{ errorMessage }}
        </div>
        <button
          type="button"
          class="btn btn-link btn-sm px-0"
          [disabled]="isBusy || resendDisabled"
          (click)="resend.emit()"
        >
          {{ 'navigations.account.email_2fa_resend' | translate }}
        </button>
      </ng-container>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-sm btn-light" (click)="cancel.emit()" [disabled]="isBusy">
        {{ 'navigations.close' | translate }}
      </button>
      <button
        *ngIf="step === 'send'"
        type="button"
        class="btn btn-sm btn-success"
        (click)="send.emit()"
        [disabled]="isBusy"
      >
        <span *ngIf="isBusy" class="spinner-border spinner-border-sm mr-1"></span>
        {{ 'navigations.account.email_2fa_send_button' | translate }}
      </button>
      <button
        *ngIf="step === 'verify'"
        type="button"
        class="btn btn-sm btn-success"
        (click)="onVerify()"
        [disabled]="isBusy || !code"
      >
        <span *ngIf="isBusy" class="spinner-border spinner-border-sm mr-1"></span>
        {{ 'navigations.account.email_2fa_verify' | translate }}
      </button>
    </div>
  `,
})
export class Email2faModalComponent {
  @Input() step: 'send' | 'verify' = 'send';
  @Input() maskedEmail = '';
  @Input() isBusy = false;
  @Input() errorMessage: string | null = null;
  @Input() resendDisabled = false;

  @Output() send = new EventEmitter<void>();
  @Output() verify = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();
  @Output() resend = new EventEmitter<void>();

  code = '';

  onVerify(): void {
    const normalized = (this.code || '').replace(/\s+/g, '');
    if (!normalized) {
      return;
    }
    this.verify.emit(normalized);
  }
}
